import { inventarioApi } from './inventarioApi';

const LEGACY_KEY = 'kardex_v1';
const MIGRATED_KEY = 'kardex_v1_migrated';

export const LEGACY_KARDEX_KEY = LEGACY_KEY;
export const LEGACY_MIGRATED_KEY = MIGRATED_KEY;

export function markLegacyMigrationComplete() {
  localStorage.setItem(MIGRATED_KEY, 'done');
  localStorage.removeItem(LEGACY_KEY);
}

export function isLegacyDataPending() {
  return localStorage.getItem(LEGACY_KEY) !== null
    && localStorage.getItem(MIGRATED_KEY) !== 'done';
}

function isAlreadyMigratedError(err) {
  const status = err?.response?.status;
  const message = String(err?.response?.data?.message || err?.message || '');
  return status === 400 && message.toLowerCase().includes('migración ya fue ejecutada');
}

/**
 * Envía todo el contenido de kardex_v1 en UN solo POST /migrate.
 * El backend se encarga de insertar cada entidad, saltando ítems
 * cuyo _id ya exista (idempotente para reintentos).
 *
 * @returns {{ ok: boolean, detail?: Object }}
 */
export async function migrateLegacyData() {
  if (!isLegacyDataPending()) return { ok: true, skipped: true };

  const raw = localStorage.getItem(LEGACY_KEY);
  if (!raw) return { ok: true, skipped: true };

  let data;
  try { data = JSON.parse(raw); }
  catch { return { ok: false, error: 'JSON inválido en kardex_v1' }; }

  // Mapear id → _id para que Mongo preserve los UUIDs originales
  const mapIds = (arr) => (arr || []).map(({ id, ...rest }) => ({ id: id, ...rest }));

  const payload = {
    config: {
      metodo: data.metodo || null,
      fechaConfigurada: data.fechaConfigurada || null,
    },
    productos:         mapIds(data.productos),
    categoriasGastos:  mapIds(data.categoriasGastos),
    movimientos:       mapIds(data.movimientos),
    gastos:            mapIds(data.gastos),
    ajustes:           mapIds(data.ajustes),
    traspasosQR:       mapIds(data.traspasosQR),
    arqueos:           mapIds(data.arqueos),
  };

  console.log('[migración] Payload a enviar:', {
    productos: payload.productos.length,
    categoriasGastos: payload.categoriasGastos.length,
    movimientos: payload.movimientos.length,
    gastos: payload.gastos.length,
    ajustes: payload.ajustes.length,
    traspasosQR: payload.traspasosQR.length,
    arqueos: payload.arqueos.length,
  });

  try {
    const result = await inventarioApi.bulkMigrate(payload);

    if (result.ok) {
      markLegacyMigrationComplete();
    }

    return result;
  } catch (err) {
    if (isAlreadyMigratedError(err)) {
      markLegacyMigrationComplete();
      return { ok: true, alreadyMigrated: true };
    }
    throw err;
  }
}
